export interface UserOverviewItem {
  AcceptPrivacyOn: string | number | Date;
  UserId: number,
  UserLastName: string,
  UserFirstName: string,
  CompanyName: string,
  Email: string,
  State: UserState,
  IsoCode: string,
  UserCountryIso: string,
  IsGold: boolean
}

export enum UserState {
  VerifyEmail = "VerifyEmail",
  WaitingApproval = "WaitingApproval",
  IsApproved = "IsApproved",
  IsDeleted = "IsDeleted"
}
